/**
 * Dependency Injection Module: Reward Catalog
 * Configures Inversify container for reward catalog feature.
 */

import { Container } from "inversify";
import type { IRewardCatalogRepository } from "../domain/repository/IRewardCatalogRepository";
import { RewardCatalogRepositoryImpl } from "../data/repository/RewardCatalogRepositoryImpl";
import { RewardCatalogApiService } from "../data/remote/service/RewardCatalogApiService";

const TYPES = {
  IRewardCatalogRepository: Symbol.for("IRewardCatalogRepository"),
};

const rewardCatalogContainer = new Container();

rewardCatalogContainer
  .bind<IRewardCatalogRepository>(TYPES.IRewardCatalogRepository)
  .to(RewardCatalogRepositoryImpl)
  .inSingletonScope();

rewardCatalogContainer.bind(RewardCatalogApiService).toSelf().inSingletonScope();

export { rewardCatalogContainer, TYPES };
